import { createRoute } from "@tanstack/react-router";
import { hubLayoutRoute } from "./PortalLayout";

export const hubIndexRoute = createRoute({
  getParentRoute: () => hubLayoutRoute,
  path: "/",
}).lazy(() => import("./PortalHome.lazy").then((d) => d.Route));
